<template>
  <AppModal heading="Add New Card" @close="closeModal(null)">
    <div slot="content" class="card-modal">
      <VCreditCard
        :direction="direction"
        @change="creditInfoChanged"
        @cardChanged="cardChanged"
      />
      <div class="pb-6">
        <button
          :disabled="!validationPassed || isSavingCard"
          class="new-app-btn bg-blue"
          type="button"
          :class="{'opacity-25': !validationPassed || isSavingCard}"
          @click="saveCard"
        >
          Save
        </button>
      </div>
    </div>
  </AppModal>
</template>
<script>
import VCreditCard from 'v-credit-card'
import 'v-credit-card/dist/VCreditCard.css'
import { mapActions } from 'vuex'

export default {
  name: 'NewCardModal',
  data() {
    return {
      validationPassed: false,
      isSavingCard: false,
      cardName: '',
      cardNumber: '',
      expiration: '',
      security: '',
      name: ''
    }
  },
  components: {
    VCreditCard
  },
  computed: {
    direction() {
      return window.innerWidth > 800 ? 'row' : 'column'
    }
  },
  methods: {
    ...mapActions ([
      'addBuyerCard'
    ]),
    closeModal(card) {
      this.$emit('close', card)
    },
    cardChanged(val) {
      this.cardName = val
    },
    creditInfoChanged(values) {
      for (const key in values) {
        this[key] = values[key];
      }
      if (this.cardNumber !== '' && this.expiration != '' && this.security !== '' && this.name != '') {
        this.validationPassed = true
      } else {
        this.validationPassed = false
      }
    },
    async saveCard() {
      if (this.cardName == null || this.isSavingCard || !this.validationPassed) return
      this.isSavingCard = true
      const exp = this.expiration.split('/')
      const result = await this.addBuyerCard({
        name: this.cardName,
        card_number: this.cardNumber,
        exp_month: exp[0],
        exp_year: exp[1],
        cvc: this.security
      })
      if (result.id) {
        this.$emit('selectNewCard', result.id)
        this.closeModal(result)
      }else {
        this.isSavingCard = false;
      }
      this.$notify({
        group: 'buyHive',
        type: result.id ? 'success' : 'error',
        text: result.message,
        duration: 7000
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .card-modal {
    /deep/.vue-credit-card
      .field {
        label {
          @apply text-sm font-medium;
        }
        input {
          @apply border border-dark-b w-full px-3 h-12 rounded-lg; 
        }
      }
  }
</style>
